module.exports = __webpack_public_path__ + "static/media/mail-to@2x.f09f7e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/mail-to@2x.png
// module id = 1889
// module chunks = 0